
import { Component, Vue } from 'vue-property-decorator';

import dialogImgLarge from '@/components/ImgLarge/index.vue';
import { getJobList, getRecordList } from '@/api/cyclCheck';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'CyclCheckJob',
  components: {
    dialogImgLarge
  },
  filters: {
    getCheckState: function(value: any) {
      let detail = '';
      switch (parseInt(value)) {
        case 0:
          detail = '未点检';
          break;
        case 1:
          detail = '正常';
          break;
        case 2:
          detail = '异常';
          break;
      }
      return detail;
    }
  }
})
export default class extends Vue {
      private listQuery = {
        page: 1,
        size: 10,
        check_name: '',
        last_check_state: ''
      }

      private listData = {
        list: [],
        total: 0
      }

      private stateOptions = [{
        value: '0',
        label: '未点检'
      }, {
        value: '1',
        label: '正常'
      }, {
        value: '2',
        label: '异常'
      }, {
        value: '9',
        label: '已点检'
      }]

      private loading = false
      private checkJobDetailVisible = false
      private jobDetailMore = false
      private jobDetailQuery:any = {
        job_id: '',
        page: 1,
        size: 10
      }
      private jobDetailData:any = []

      private activeName = 'first'

      created() {
        this.getCheckJobList();
      }
      // 历史记录
      private checkRecord(id: string) {
        this.$router.push({
          path: '/cyclCheck/record',
          query: { 'id': id }
        });
      }
      // 当日点检 传今日时间
      private getCheckJobList() {
        let nowData = new Date();
        let y = nowData.getFullYear();
        let m = nowData.getUTCMonth() + 1;
        let d = nowData.getDate();
        let _this = this;
        this.loading = true;
        let parameters:any = {};
        parameters.user_id = UserModule.getUserId;
        parameters.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
        parameters.start_time = new Date(y, m - 1, d, 0, 0, 0).getTime() / 1000;
        parameters.end_time = new Date(y, m - 1, d, 23, 59, 59).getTime() / 1000;
        if (this.listQuery.check_name) {
          parameters.check_name = this.listQuery.check_name;
        }
        if (this.listQuery.last_check_state) {
          parameters.last_check_state = this.listQuery.last_check_state;
        }
        getJobList(parameters).then(res => {
          if (res.data != null) {
            _this.listData.list = res.data.list;
            _this.listData.total = res.data.count;
          } else {
            _this.listData.list = [];
            _this.listData.total = 0;
          }
          _this.loading = false;
        }).catch(err => {
          let msg = err.msg;
        });
      }
      // 获取详情
      private getCheckJobDetail(item: any) {
        let _this = this;
        this.jobDetailQuery.job_id = item.id;
        this.checkJobDetailVisible = true;
        this.jobDetailMore = false;
        this.jobDetailQuery.user_id = UserModule.getUserId;
        this.jobDetailQuery.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
        getRecordList(this.jobDetailQuery).then(res => {
          if (res.data) {
            if (_this.jobDetailQuery.page === 1) {
              _this.jobDetailData = res.data.list;
            } else {
              if (res.data.list && res.data.list.length) {
                for (var i = 0; i < res.data.list.length; i++) {
                  _this.jobDetailData.push(res.data.list[i]);
                }
              }
            }
            // 是否 显示加载更多
            if (_this.jobDetailData.length < res.data.count) {
              _this.jobDetailMore = true;
            } else {
              _this.jobDetailMore = false;
            }
          } else {
            _this.jobDetailData = [];
          }
        }).catch(err => {
          let msg = err.msg;
        });
      }
      // 加载更多详情
      private moreJobDetailData() {
        this.jobDetailQuery.page += 1;
        this.getCheckJobDetail({ id: this.jobDetailQuery.job_id });
      }
      // 关闭详情
      private JobDetailClose() {
        this.jobDetailQuery = {
          job_id: '',
          page: 1,
          size: 10 };
        this.checkJobDetailVisible = false;
      }
      // 图片 视频播放
      private handleMedia(val: [], index: number) {
        let value;
        if (typeof val === 'object') {
          value = val;
        } else {
          value = [{ video_url: val }];
        }
        let enlargedData = {
          isShow: true,
          imgList: value,
          initNum: index
        };
        this.$store.dispatch('toggleEnlarged', enlargedData);
      }
      // 搜索
      private search() {
        this.listQuery.page = 1;
        this.listData.list = [];
        this.listData.total = 0;
        this.getCheckJobList();
      }
      // 重置
      private clear() {
        this.listQuery.page = 1;
        this.listQuery.check_name = '';
        this.listQuery.last_check_state = '';
        this.listData.list = [];
        this.listData.total = 0;
        this.getCheckJobList();
      }
      private handleSizeChange(size: number) {
        this.listQuery.size = size; // 每页下拉显示数据
        this.getCheckJobList();
      }
      private handleCurrentChange(page: number) {
        this.listQuery.page = page; // 点击第几页
        this.getCheckJobList();
      }
}
